import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/30 selection:text-charcoal" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <RevelationSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <OfferSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <FAQSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <ClosingSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}